<template>
  <el-dialog :title="isUpdate ? '修改银行卡' : '添加银行卡'" :visible="visible" width="900px" :destroy-on-close="true"
    :lock-scroll="false" @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :sm="12">
          <el-form-item label="小组名称:" prop="class_id">
            <el-select clearable class="ele-block" v-model.trim="form.class_id" placeholder="请选择">
              <el-option v-for="item in classList" :key="item.id" :value="item.id" :label="item.classname" />
            </el-select>
          </el-form-item>
          <el-form-item label="渠道类型:" prop="type_code">
            <el-select clearable filterable class="ele-block" v-model="form.type_code" placeholder="请选择">
              <el-option v-for="item in channeltypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="银行名称:" prop="bank_name">
            <el-input clearable :maxlength="20" v-model.trim="form.bank_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="分行名称:">
            <el-input clearable :maxlength="20" v-model.trim="form.branch_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="支持金额:" prop="in_money">
            <el-input clearable :maxlength="20" v-model.trim="form.in_money" placeholder="英文 , 号分割" />
          </el-form-item>
        </el-col>

        <el-col :sm="12">
          <el-form-item label="收款名称:" prop="account_name">
            <el-input clearable :maxlength="20" v-model.trim="form.account_name" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="银行账户:" prop="account_number">
            <el-input clearable :maxlength="20" v-model.trim="form.account_number" placeholder="请输入" />
          </el-form-item>
          <el-form-item :label="isUpdate ? '实际余额:' : '初始余额:'" prop="sj_amount">
            <el-input clearable :maxlength="20" v-model.trim="form.sj_amount" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="风控上限:" prop="fk_money">
            <el-input clearable :maxlength="20" v-model.trim="form.fk_money" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="24">
          <el-form-item label="二维码图片:">
            <uploadImage :limit="1" v-model="form.qr_image" @change="onQrUpload" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)"><b>取消</b></el-button>
      <el-button type="primary" @click="save" :loading="loading"><b>确定</b></el-button>
    </div>
  </el-dialog>
</template>

<script>
import uploadImage from "@/components/uploadImage.vue";

export default {
  name: "RecolumnEdit",
  components: {
    uploadImage,
  },
  props: {
    // 弹窗是否打开
    visible: Boolean,
    // 修改回显的数据
    data: Object,
  },
  data() {
    return {
      // 表单数据
      form: Object.assign({ status: 1, status_up: 2, is_dk: 2, qr_image: "", qr_code: "", type_code: "" }, this.data),
      // 表单验证规则
      rules: {
        class_id: [
          { required: true, message: "请选择资源分类", trigger: "blur" },
        ],
        type_code: [
          { required: true, message: "请选择渠道类型", trigger: "change" },
        ],

        account_name: [
          {
            required: true,
            message: "请输入收款名称 例如：司藤",
            trigger: "blur",
          },
        ],
        bank_name: [
          {
            required: true,
            message: "请输入银行名称 例如：中国银行",
            trigger: "blur",
          },
        ],
        sj_amount: [
          {
            required: true,
            message: "请输入初始金额 例如:2",
            trigger: "blur",
          },
        ],
        account_number: [
          {
            required: true,
            message: "请输入银行账户 例如:62220012225315476",
            trigger: "blur",
          },
        ],

        in_money: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        status_up: [
          { required: true, message: "请选择上线状态", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择银行状态", trigger: "blur" },
        ],
        fk_money: [
          { required: true, message: "请输入风控上限金额 例如:20000", trigger: "blur" },
        ],
      },
      // 提交状态
      loading: false,
      // 是否是修改
      isUpdate: false,
      // 分类列表
      classList: [],
      channeltypeOptions: [],
    };
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({ type_code: "" }, this.data);
        this.isUpdate = true;
      } else {
        this.form = { status: 1, status_up: 2, is_dk: 2, qr_image: "", qr_code: "", type_code: "" };
        this.isUpdate = false;
      }
    },
  },
  mounted() {
    this.queryClass(); // 查询财务列表
    this.getChanneltypeOptions();
  },
  methods: {
    onQrUpload(data) {
      // 确保正确接收二维码数据
      if (data && typeof data === 'object') {
        // qr_image 已经通过 v-model 自动更新，这里只需要更新 qr_code
        if (data.qr_code !== undefined) {
          this.form.qr_code = data.qr_code || "";
        }
        // 确保 qr_image 也正确设置（虽然 v-model 已经处理了，但为了保险起见）
        if (data.qr_image !== undefined) {
          this.form.qr_image = data.qr_image || "";
        }
      }
    },
    /* 保存编辑 */
    save() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http
            .post("/resourcecolumn/editTo", this.form)
            .then((res) => {
              this.loading = false;
              if (res.data.code === 0) {
                this.$message.success(res.data.msg);
                if (!this.isUpdate) {
                  this.form = {};
                }
                this.updateVisible(false);
                this.$emit("done");
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((e) => {
              this.loading = false;
              this.$message.error(e.message);
            });
        } else {
          return false;
        }
      });
    },
    /* 更新visible */
    updateVisible(value) {
      this.$emit("update:visible", value);
    },
    /* 查询财务列表 */
    queryClass() {
      this.$http
        .get("/Resourceclass/getClassList")
        .then((res) => {
          if (res.data.code === 0) {
            this.classList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    getChanneltypeOptions() {
      this.$http
        .get("/channeltype/options")
        .then((res) => {
          if (res.data.code === 0) {
            this.channeltypeOptions = res.data.data || [];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
  },
};
</script>

<style scoped></style>
